import Axios from "axios";

export const SelectReleveFrc = (z ,f, g, a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/ReleveFournisseur?codefrc=${z}&vendeur=${f}&grp=${g}&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "RELEVERFRC_GET", payload: response.data });
    });
  };
};
